import { handleInteractiveKeydown } from '@fullstory/util/a11y';
import React, { useContext } from 'react';
import { BaseItem } from './BaseItem';
import { Context } from './Context';
import css from './index.module.scss';

export interface ActionItemProps {
  onClick: () => void;
  label: string;
}

export const ActionItem: React.FunctionComponent<ActionItemProps> = ({ onClick, label }) => {
  const { testId } = useContext(Context);
  return (
    <span
      data-component="InfoListActionItem"
      role="button"
      tabIndex={0}
      data-testid={`${testId}-actionItem`}
      onClick={onClick}
      onKeyDown={handleInteractiveKeydown(onClick)}
      style={{ display: 'inline-flex' }}
    >
      <BaseItem className={css.actionableListItem}>{label}</BaseItem>
    </span>
  );
};
